import React from 'react'
import { Button, Position, ButtonProps, PopoverInteractionKind } from '@blueprintjs/core'
import { Tooltip2 } from '@blueprintjs/popover2'
import { Icon } from '..'
import { get } from 'lodash'

interface IUIIconButtonProps extends ButtonProps {
  iconName: string
  tooltip?: string
  tooltipPosition?: Position
  round?: boolean
  blue?: boolean
  iconClassName?: string
  style?: React.CSSProperties
  'data-button'?: string
}

export default function IconButton({
  iconName,
  tooltip,
  tooltipPosition = Position.TOP,
  round = true,
  blue,
  style,
  iconClassName,
  ...buttonProps
}: IUIIconButtonProps) {
  let className = get(buttonProps, 'className', '')
  if (round) {
    className += ' round'
  }
  if (blue) {
    className += ' blue-button'
  }

  const width = buttonProps && buttonProps.large ? 40 : 32
  const height = buttonProps && buttonProps.large ? 40 : 32

  return tooltip ? (
    <Tooltip2
      content={tooltip}
      position={tooltipPosition}
      interactionKind={PopoverInteractionKind.HOVER_TARGET_ONLY}
    >
      <Button
        {...buttonProps}
        style={{ ...style, width, height }}
        className={className}
        icon={<Icon name={iconName} className={iconClassName} />}
      />
    </Tooltip2>
  ) : (
    <Button {...buttonProps} style={style} className={className} icon={<Icon name={iconName} />} />
  )
}
